var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.246 6.58718C3.20733 6.54951 3.042 6.40728 2.906 6.27479C2.05067 5.49804 0.650667 3.47174 0.223333 2.41118C0.154667 2.25011 0.00933333 1.8429 0 1.62533C0 1.41686 0.048 1.21813 0.145333 1.02848C0.281333 0.792083 0.495333 0.602441 0.748 0.498529C0.923333 0.431635 1.448 0.327722 1.45733 0.327722C2.03133 0.223809 2.964 0.166656 3.99467 0.166656C4.97667 0.166656 5.87133 0.223809 6.454 0.308887C6.46333 0.318629 7.11533 0.422542 7.33867 0.536197C7.74667 0.744672 8 1.15188 8 1.58767V1.62533C7.99 1.90915 7.73667 2.506 7.72733 2.506C7.29933 3.50941 5.968 5.48895 5.08333 6.28453C5.08333 6.28453 4.856 6.50859 4.714 6.60601C4.51 6.75799 4.25733 6.83332 4.00467 6.83332C3.72267 6.83332 3.46 6.74824 3.246 6.58718Z",
    fill: "#2C3782"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownCollapse);
export default __webpack_public_path__ + "static/media/ArrowDownCollapse.293f1999.svg";
export { ForwardRef as ReactComponent };